export class UsersQuery {
  static get KEYS () {
    return {
      USER: 'user',
      GROUP: 'group'
    };
  }
}
